import { useEffect, useState } from 'react';

export const useMouseWheel = () => {
  const [delta, setDelta] = useState({ x: 0, y: 0 });
  const [wheeling, setWheeling] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    let timer;
    const setFromEvent = (ev: WheelEvent) => {
      setWheeling(true);

      clearTimeout(timer);
      timer = setTimeout(() => {
        setWheeling(false);
        setDelta({ x: 0, y: 0 });
      }, 250);

      setPosition({ x: ev.pageX, y: ev.pageY });
      setDelta({ x: ev.deltaX, y: ev.deltaY });
    };
    window.addEventListener('wheel', setFromEvent);

    return () => {
      window.removeEventListener('wheel', setFromEvent);
    };
  }, []);

  return { delta, wheeling, position };
};
